<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Taksonomi Bloom",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_taksonomi",
      },
      {
        width: "auto",
        label: "Kode",
        name: "kode",
      },
      {
        width: "auto",
        label: "Level Koginitif",
        name: "level_kognitif",
      },
      {
        width: "auto",
        label: "Deskripsi",
        name: "deskripsi",
      },
      {
        width: "auto",
        label: "Indikator",
        name: "indikator",
      },
      {
        width: "auto",
        label: "Kata Kerja Operasional",
        name: "kata_kunci",
      },
      {
        width: "auto",
        label: "Contoh Bentuk Soal",
        name: "bentuk_soal",
      },
      {
        width: "150px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Taksonomi Bloom";

    return {
      title: menu,
      // isWrite: localStorage.getItem("isWrite"),
      isWrite: 1,
      showModal: false,
      isEdit: false,
      selected_id: "",
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_taksonomi", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_taksonomi",
        dir: "desc",
        filter: {
          active_flag: 1,
        },
      },

      form: {
        kode: "",
        level_kognitif: "",
        deskripsi: "",
        indikator: "",
        kata_kunci: "",
        bentuk_soal: "",
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  async mounted() {
    let self = this;
    await self.getDataTable();
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/taksonomi",
    ) {
      let self = this;
      self.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        params: self.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            console.log(response_data_fix);
            self.table_data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.currentTablePage = response_data_fix.current_page;
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(page) {
      let self = this;
      self.tableFilter.page = page;
      self.getDataTable();
    },
    resetForm() {
      this.form = {
        kode: "",
        level_kognitif: "",
        deskripsi: "",
        indikator: "",
        kata_kunci: "",
        bentuk_soal: "",
      };
      this.selected_id = "";
    },
    create() {
      this.resetForm();
      this.isEdit = false;
      this.showModal = true;
    },
    edit(data) {
      this.isEdit = true;
      this.selected_id = data.idverif_taksonomi;
      this.form = {
        kode: data.kode,
        level_kognitif: data.level_kognitif,
        deskripsi: data.deskripsi,
        indikator: data.indikator,
        kata_kunci: data.kata_kunci,
        bentuk_soal: data.bentuk_soal,
      };
      this.showModal = true;
    },
    save() {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/taksonomi";
      let method = "post";

      if (self.isEdit) {
        url += "/" + self.selected_id;
        method = "put";
      }

      Swal.fire({
        title: "Sedang memproses data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios({
        method: method,
        url: url,
        data: self.form,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          if (response.data.meta.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: response.data.meta.message,
            });
            self.showModal = false;
            self.getDataTable();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          let message = "Terjadi kesalahan";

          const metaMessage = error?.response?.data?.meta?.message;
          const validationErrors = error?.response?.data?.data?.error;

          if (
            metaMessage === "Validation failed" &&
            Array.isArray(validationErrors)
          ) {
            message = `
              <ul style="text-align:left;">
                ${validationErrors.map((err) => `<li>${err}</li>`).join("")}
              </ul>
            `;
          } else if (metaMessage) {
            message = metaMessage;
          }

          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: message, // pakai html, bukan text
          });
        });
    },
    changeStatus(data) {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/taksonomi/" +
        data.idverif_taksonomi +
        "/status";
      let method = "put";

      Swal.fire({
        title: "Apakah anda yakin?",
        text:
          data.active_flag == 1
            ? "Data akan dinonaktifkan!"
            : "Data akan diaktifkan kembali!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                self.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    deleteData(data) {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/taksonomi/" +
        data.idverif_taksonomi;
      let method = "delete";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data akan dihapus secara permanen!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                self.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <!-- <div class="card-title">List Data</div> -->
              </div>
              <div class="col-md-6">
                <div class="text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="create()"
                    v-if="isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i> Tambah
                  </button>
                </div>
              </div>
              <div class="row mt-2">
                <hr />
                <div class="form-group col-md-3">
                  <label for="filterStatus">Status</label>
                  <select
                    class="form-control"
                    id="filterStatus"
                    v-model="tableFilter.filter.active_flag"
                    @change="getDataTable()"
                  >
                    <option value="1">Aktif</option>
                    <option value="0">Tidak Aktif</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <hr />
                <div class="col-12">
                  <table class="mb-2">
                    <tr>
                      <td>Show</td>
                      <td>
                        <select
                          class="form-control form-control-sm"
                          id="showpaginatetable"
                          v-model="tableFilter.per_page"
                          @change="getDataTable()"
                        >
                          <option value="10">10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                          <option value="500">500</option>
                        </select>
                      </td>
                      <td>Entries</td>
                    </tr>
                  </table>
                </div>

                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td class="text-center" colspan="99">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data == ''">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td>{{ key_data + pagination.from }}</td>
                      <td>
                        {{ row_data.kode }}
                      </td>
                      <td>
                        {{ row_data.level_kognitif }}
                      </td>
                      <td>
                        {{ row_data.deskripsi }}
                      </td>
                      <td>
                        {{ row_data.indikator }}
                      </td>
                      <td>
                        {{ row_data.kata_kunci }}
                      </td>
                      <td>
                        {{ row_data.bentuk_soal }}
                      </td>
                      <td class="text-center">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite == 1 && row_data.active_flag == 1"
                            v-on:click="edit(row_data)"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-if="isWrite == 1 && row_data.active_flag == 1"
                            @click="changeStatus(row_data)"
                          >
                            <i class="fa fa-trash"></i> Disable
                          </button>
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite == 1 && row_data.active_flag == 0"
                            @click="changeStatus(row_data)"
                          >
                            <i class="fa fa-recycle"></i> Enable
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-if="isWrite == 1 && row_data.active_flag == 0"
                            v-on:click="deleteData(row_data)"
                          >
                            <i class="fa fa-trash"></i> Hapus
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Taksonomi Bloom' : 'Tambah Taksonomi Bloom'"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <form @submit.prevent="save">
        <div class="form-group mb-3">
          <label>Kode <span class="text-danger">*</span></label>
          <input
            v-model="form.kode"
            type="text"
            class="form-control"
            placeholder="Masukkan Kode"
          />
        </div>
        <div class="form-group mb-3">
          <label>Level Kognitif <span class="text-danger">*</span></label>
          <input
            v-model="form.level_kognitif"
            type="text"
            class="form-control"
            placeholder="Masukkan Level Kognitif"
          />
        </div>
        <div class="form-group mb-3">
          <label>Deskripsi</label>
          <input
            v-model="form.deskripsi"
            type="text"
            class="form-control"
            placeholder="Masukkan Deskripsi"
          />
        </div>
        <div class="form-group mb-3">
          <label>Indikator</label>
          <input
            v-model="form.indikator"
            type="text"
            class="form-control"
            placeholder="Masukkan Indikator"
          />
        </div>
        <div class="form-group mb-3">
          <label>Kata Kerja Operasional</label>
          <input
            v-model="form.kata_kunci"
            type="text"
            class="form-control"
            placeholder="Masukkan Kata Kerja Operasional"
          />
        </div>
        <div class="form-group mb-3">
          <label>Contoh Bentuk Soal</label>
          <input
            v-model="form.bentuk_soal"
            type="text"
            class="form-control"
            placeholder="Masukkan Contoh Bentuk Soal"
          />
        </div>
        <div class="text-end mt-4">
          <button
            type="button"
            class="btn btn-light me-1"
            @click="showModal = false"
          >
            Tutup
          </button>
          <button type="submit" class="btn btn-success">Simpan</button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
